import { Loading, Toast } from 'vant';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    [Loading.name]: Loading,
  }
})
export default class InitialPage extends Vue {

  /**
   * 1.微信公众号首先跳转到该页面
   * 2.首先获取openid，获取后存入缓存中
   * 3.获取openid后，检验是否绑定过手机号，若未绑定，则先跳转到绑定手机号页面
   * 4.跳转到我的页面
   */
  created() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    });
    // 获取openid
    this.getOpenId();
  }
  getOpenId() {
    const query = new URLSearchParams(location.href.split('?')[1]);
    const isPool = this.getIsPool(query);
    const user = this.getUserWithURLSearchParams(query);
    if (user.openid && user.unionid) {
      // user.openid = '123';// 暂时写死的
      sessionStorage.setItem('wechatUser', JSON.stringify(user));
      sessionStorage.setItem('isPool', isPool + '');
      console.log(user);
      Toast.clear();
      const uri = location.origin;
      // this.$router.push({ path: '/redirect' });
      location.href = uri + '#/redirect?isPool=' + isPool;
    } else {
      const uri = location.origin + '?isPool=' + isPool;
      location.href = 'http://scrm.lunz.cn/OpenOAuth/getuserinfo?appId=wx70cfc5b45951c5c8&fromurl=' + encodeURI(uri);
    }
  }
  getUserWithURLSearchParams(query: URLSearchParams) {
    const user = {
      nickname: query.get('nickname') || '',
      headimgurl: query.get('headimgurl') || '',
      openid: query.get('openid') || '',
      unionid: query.get('unionid') || ''
    }
    return user;
  }
  getIsPool(query: URLSearchParams) {
    const isPool = query.get('isPool') || '1';
    return isPool;
  }
}